import { Box, Flex } from "@chakra-ui/react";
import { buildPieChartStyles } from "./utils";
import ChartIndicator from "./ChartIndicator";
import PieChartText from "./PieChartText";
import type { PieChartProps } from "./PieChart.d";

const PieChartPrimary = ({ variant, text, chartValue }: PieChartProps) => {
  const customStyles = { paragraph: { fontSize: "xl" } };

  return (
    <Flex flexDirection="row" width="100%">
      <Box>
        <Box sx={buildPieChartStyles(variant, chartValue)} />
      </Box>
      <Box zIndex="1" textAlign="end" overflow="auto" ml="-30px">
        <PieChartText text={text} styles={customStyles} />
        <ChartIndicator />
      </Box>
    </Flex>
  );
};

export default PieChartPrimary;
